const publicData={
	isShowLoading : true,  //控制全局加载动画。  true开启   false关闭
	taskTypeArr: [{
			name: '管理咨询',
			num: '1'
		},{
			name: '影视文化',
			num: '2'
		},{
			name: '贸易服务',
			num: '3'
		},{
			name: '生产制造',
			num: '4'
		},{
			name: '共享经济',
			num: '5'
		},{
			name: '商业服务',
			num: '6'
		},{
			name: '物流服务',
			num: '7'
		},{
			name: '餐饮服务',
			num: '8'
		},{
			name: '工程咨询',
			num: '9'
		},{
			name: '电子商务',
			num: '10'
		},{
			name: '教育培训',
			num: '11'
		},{
			name: '互联网科技',
			num: '12'
		}
	], //任务类型集合
	industryArr:[
		{
			name:'农、林、牧、渔业',
			id:'1'
		},{
			name:'采矿业',
			id:'2'
		},{
			name:'制造业',
			id:'3'
		},{
			name:'电力、热力、燃气及水生产和供应业',
			id:'4'
		},{
			name:'建筑业',
			id:'5'
		},{
			name:'批发和零售业',
			id:'6'
		},{
			name:'交通运输、仓储和邮政业',
			id:'7'
		},{
			name:'住宿和餐饮业',
			id:'8'
		},{
			name:'信息传输、软件和信息技术服务业',
			id:'9'
		},{
			name:'金融业',
			id:'10'
		},{
			name:'房地产业',
			id:'11'
		},{
			name:'租赁和商务服务业',
			id:'12'
		},{
			name:'科学研究和技术服务业',
			id:'13'
		},{
			name:'水利、环境和公共设施管理业',
			id:'14'
		},{
			name:'居民服务、修理和其他服务业',
			id:'15'
		},{
			name:'教育',
			id:'16'
		},{
			name:'卫生和社会工作',
			id:'17'
		},{
			name:'文化、体育和娱乐业',
			id:'18'
		},{
			name:'公共管理、社会保障和社会组织',
			id:'19'
		},{
			name:'其他行业',
			id:'20'
		},
	],//所属行业集合
	invoiceArr:[
		{
			name:'*现代服务*信息技术服务',
			id:'1'
		},{
			name:'*现代服务*技术服务',
			id:'2'
		},{
			name:'*现代服务*技术咨询服务',
			id:'3'
		},{
			name:'*现代服务*其他咨询服务',
			id:'4'
		},{
			name:'*现代服务*业务外包服务',
			id:'5'
		},{
			name:'*现代服务*商务辅助服务',
			id:'6'
		},{
			name:'*现代服务*设计服务费',
			id:'7'
		},{
			name:'*现代服务*营销策划服务费',
			id:'8'
		},{
			name:'*现代服务*营销服务费',
			id:'9'
		},{
			name:'*现代服务*仓储搬运费',
			id:'10'
		},{
			name:'*现代服务*物流辅助服务',
			id:'11'
		},{
			name:'*现代服务*信息系统服务',
			id:'12'
		},{
			name:'*现代服务*企业管理服务',
			id:'13'
		},{
			name:'*现代服务*市场营销策划',
			id:'14'
		},{
			name:'*现代服务*人力资源服务',
			id:'15'
		},{
			name:'*现代服务*市场推广服务',
			id:'16'
		},{
			name:'*现代服务*经纪服务费',
			id:'17'
		},{
			name:'*现代服务*咨询服务',
			id:'18'
		},{
			name:'*现代服务*企业形象策划咨询',
			id:'19'
		},{
			name:'*设计服务*市场营销策划',
			id:'20'
		},{
			name:'*信息技术服务*其他软件服务',
			id:'21'
		},{
			name:'*信息技术服务*其他软件开发服务费',
			id:'22'
		},{
			name:'*信息技术服务*软件运行维护服务',
			id:'23'
		},{
			name:'*信息技术服务*软件开发服务费',
			id:'24'
		},{
			name:'*信息技术服务*软件测试',
			id:'25'
		},{
			name:'*信息技术服务*信息系统集成服务',
			id:'26'
		},{
			name:'*信息技术服务*信息处理和存储支持服务',
			id:'27'
		},{
			name:'*信息技术服务*网络运行维护服务',
			id:'28'
		},{
			name:'*信息技术服务*硬件运行维护服务',
			id:'29'
		},{
			name:'*其他咨询服务*翻译服务',
			id:'30'
		},{
			name:'*其他咨询服务*企业管理咨询',
			id:'31'
		},{
			name:'*其他咨询服务*商务信息咨询',
			id:'32'
		},{
			name:'*其他咨询服务*市场调查',
			id:'33'
		},{
			name:'*其他咨询服务*技术咨询',
			id:'34'
		},{
			name:'*一般税务咨询*咨询服务',
			id:'35'
		},{
			name:'*企业管理服务*其他企业管理服务',
			id:'36'
		},{
			name:'*企业管理服务*会议咨询费',
			id:'37'
		},{
			name:'*人力资源服务*服务费',
			id:'38'
		},{
			name:'*人力资源服务*外包服务费',
			id:'39'
		},{
			name:'*人力资源服务*人才委托招聘',
			id:'40'
		},{
			name:'*人力资源服务*人力资源服务（劳务派遣除外）',
			id:'41'
		},{
			name:'工程设计及咨询服务',
			id:'42'
		},{
			name:'保洁服务',
			id:'43'
		},{
			name:'物流辅助服务*装卸服务',
			id:'44'
		}
	], //发票类目集合
	

	
	
	
	
	
	
	
}
export{publicData};


// WEBPACK FOOTER //
// ./src/assets/js/data.js